import React from 'react';
import { number, node } from 'prop-types';

export const ParameterizedIcon = ({ size, children }) => (
    <span
        style={{
            width: `${size}px`,
            height: `${size}px`,
        }}
    >
        {children}
    </span>
);

ParameterizedIcon.propTypes = {
    size: number,
    children: node,
};
